import React, { ReactNode } from 'react';
import styled, { DefaultTheme, withTheme } from 'styled-components';
import { Header2Text, FormCell, Grid, SpacerRow, Card } from 'ui-toolkit';
import { ExpectedBorrowerMoneyLabel } from '../ExpectedBorrowerMoneyLabel';
import { ExpectedBuyerMoneyLabel } from '../ExpectedBuyerMoneyLabel';
import { ExpectedLenderMoneyLabel } from '../ExpectedLenderMoneyLabel';
import { eTransactionCategory } from '../../../../../ui-toolkit/enums/eTransactionType';

const RoomyGrid = styled(Grid)`
  gap: ${(props) => props.theme.spacing.spacing5};
`;

export interface IEscrowExpectedHeaderProps {
  expectedBorrowerCash: ReactNode;
  expectedBuyerCash: ReactNode;
  expectedLenderCash: ReactNode;
  loanAmount: number | null;
  transactionCategory: eTransactionCategory;
  theme?: DefaultTheme;
}

const SpaEscrowExpectedHeader_: React.FC<IEscrowExpectedHeaderProps> = ({
  expectedBorrowerCash,
  expectedBuyerCash,
  expectedLenderCash,
  loanAmount,
  transactionCategory,
  theme,
}) => {
  return (
    <Card contentPadding={theme?.spacing.spacing7}>
      <Header2Text>Expected</Header2Text>
      <SpacerRow />
      <RoomyGrid>
        {transactionCategory === eTransactionCategory.Refinance && (
          <FormCell label={<ExpectedBorrowerMoneyLabel />}>{expectedBorrowerCash}</FormCell>
        )}
        {transactionCategory === eTransactionCategory.Purchase && (
          <FormCell label={<ExpectedBuyerMoneyLabel />}>{expectedBuyerCash}</FormCell>
        )}
        {loanAmount !== null && loanAmount > 0 && (
          <FormCell label={<ExpectedLenderMoneyLabel />}>{expectedLenderCash}</FormCell>
        )}
      </RoomyGrid>
    </Card>
  );
};

export const SpaEscrowExpectedHeader = withTheme(SpaEscrowExpectedHeader_);
